// extracted by mini-css-extract-plugin
export default {"wrapper":"WF-z","viewport":"XF-z","container":"YF-z","slide":"ZF-z"};